import { IconNames, FillColours } from '../Icon/IconNames';

export const IconCardInputs = [
  {
    name: 'title',
    type: 'string',
    defaultValue: 'Enter a title',
  },
  {
    name: 'icon',
    type: 'enum',
    defaultValue: IconNames[0],
    enum: IconNames.map((n) => ({ label: n, value: n })),
  },
  {
    name: 'fillColour',
    type: 'enum',
    defaultValue: FillColours[0],
    enum: FillColours.map((n) => ({ label: n, value: n })),
  },
  {
    name: 'vCentre',
    friendlyName: 'Vertically centre content',
    type: 'boolean',
    defaultValue: false,
  },
  {
    name: 'contents',
    type: 'richText',
    defaultValue: '<p>Enter the content here...</p>',
  },
];
